import { render, staticRenderFns } from "./ManageTechnicianPage.vue?vue&type=template&id=01a8fe33&scoped=true&"
import script from "./ManageTechnicianPage.vue?vue&type=script&lang=js&"
export * from "./ManageTechnicianPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageTechnicianPage.vue?vue&type=style&index=0&id=01a8fe33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8fe33",
  null
  
)

export default component.exports